module.exports = __webpack_public_path__ + "img/homePageCouponsPopBg.7404a278.png";